/**
 * Task 7 - wear score. Higher = worn more / more recently / starred / in season.
 *   wears in the last 60 days      x10
 *   days since last worn           +20 today -> 0 at 60+ days (never worn = 0)
 *   starred (favourite / stars)    +15 favourite, +3 per wear-likelihood star
 *   in season                      +10
 */
export const currentSeason = (d = new Date()) => {
  const m = d.getMonth(); // 0-11
  if (m === 11 || m <= 1) return "winter";
  if (m <= 4) return "spring";
  if (m <= 7) return "summer";
  return "fall";
};

export const daysSince = (iso) => {
  if (!iso) return null;
  const t = new Date(String(iso).slice(0, 10) + "T00:00:00").getTime();
  if (Number.isNaN(t)) return null;
  return Math.max(0, Math.floor((Date.now() - t) / 86400000));
};

export const wearScore = (item, season = currentSeason()) => {
  const wears60 = Number(item.wears_60d || 0);
  const ds = daysSince(item.last_worn_at);
  const recency = ds == null ? 0 : Math.max(0, 20 - (ds / 60) * 20);
  const starred = (item.favorite ? 15 : 0) + 3 * Number(item.wear_likelihood || 0);
  const inSeason = (item.seasons || []).includes(season) ? 10 : 0;
  return wears60 * 10 + recency + starred + inSeason;
};

/** "Rarely worn": nothing in 60 days and either never worn or last worn 60+ days ago. */
export const rarelyWorn = (item) => Number(item.wears_60d || 0) === 0 && (daysSince(item.last_worn_at) == null || daysSince(item.last_worn_at) >= 60);

export const byWearScore = (a, b) => wearScore(b) - wearScore(a) || (b.created_at || "").localeCompare(a.created_at || "");
